import { makeObservable, observable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'

import i18n from 'modules/core/lib/i18n'

import { AttachedFile } from './AttachedFile'
import { Block } from './Block'

export type ContentModuleConfig = {
  uuid?: string
  title?: string
  description?: string | null
  thumbnail?: AttachedFile
  blocks?: Block[]
}

export class ContentModule {
  title: string

  description: string | null | undefined = ''

  uuid: string

  blocks: Block[] = []

  thumbnail?: AttachedFile

  constructor({
    uuid,
    title = '',
    description = '',
    thumbnail,
    blocks = [],
  }: ContentModuleConfig = {}) {
    this.uuid = uuid || uuidv4()
    this.title = title
    this.description = description
    this.thumbnail = thumbnail
    this.blocks = blocks

    makeObservable(this, {
      title: observable,
      description: observable,
      uuid: observable,
      blocks: observable,
      thumbnail: observable,
    })
  }

  clone(): ContentModule {
    return new ContentModule({
      uuid: this.uuid,
      title: this.title,
      description: this.description,
      thumbnail: this.thumbnail,
      blocks: this.blocks,
    })
  }

  addBlock(block: Block): void {
    this.blocks.push(block)
  }

  deleteBlock(uuid: string): void {
    this.blocks = this.blocks.filter((block) => block.uuid !== uuid)
  }

  getBlockByUuid(uuid: string): Block | undefined {
    return this.blocks.find((block) => block.uuid === uuid)
  }

  updateBlock(uuid: string, updatedBlock: Block): void {
    const blockIndex = this.blocks.findIndex((block) => block.uuid === uuid)
    if (blockIndex !== -1) {
      this.blocks[blockIndex] = updatedBlock
    }
  }

  validate(): Record<string, string> {
    const errors: Record<string, string> = {}

    if (!this.title.trim()) {
      errors.title = i18n.t('trainings.content.validation.title_required')
    } else if (this.title.length > 255) {
      errors.title = i18n.t('trainings.content.validation.title_maxlength')
    }
    return errors
  }
}
